import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10 7.3a1 1 0 0 0-1.4 0l-3 3.4a1 1 0 0 0 0 1.2l3 3.3A1 1 0 1 0 10 14l-1.6-1.7h9.1a1 1 0 1 0 0-1.8h-9L10 8.7c.3-.4.3-1 0-1.4",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }